module.exports = __webpack_public_path__ + "static/media/circle_grey.cd06e829.png";